import { render, staticRenderFns } from "./LabTestReport.vue?vue&type=template&id=3bd1dc4f&scoped=true&"
import script from "./LabTestReport.vue?vue&type=script&lang=js&"
export * from "./LabTestReport.vue?vue&type=script&lang=js&"
import style0 from "./LabTestReport.vue?vue&type=style&index=0&id=3bd1dc4f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd1dc4f",
  null
  
)

export default component.exports